import { gql } from '@apollo/client';

export const FETCH_AI_CREDITS = gql`
  query findRemovebgCredits {
    findRemovebgCredits {
      edges {
        node {
          freeCreditsAmount
          paidCreditsAmount
        }
      }
    }
  }
`;

export const FETCH_AI_CREDITS_ORDERS = gql`
  query findRemovebgCreditsOrders(
    $first: Int
    $skip: Int
    $where: Removebg_ordersWhereInput
    $order: [Removebg_ordersOrder!]
  ) {
    findRemovebgOrders(
      first: $first
      skip: $skip
      where: $where
      order: $order
    ) {
      count
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          objectId
          createdAt
          freeCreditsAmount
          paidCreditsAmount
          note
          isPaid
          paymentReference
          transactionDate
          transactionStatus
          usedBy
        }
      }
    }
  }
`;
